import type { ReactNode } from 'react';
import { diffWords } from 'diff';

import styles from './Diff.module.css';

export function buildAddedLineWordDiffSpans(
  prevRemovedValue: string,
  addedValue: string,
  lineNumber: number,
): ReactNode[] {
  return diffWords(prevRemovedValue, addedValue).map((change, index) => {
    if (change.added) {
      return (
        <span className={styles.addedInner} key={`added-${lineNumber}-${index}`} data-line-added-inner>
          {change.value}
        </span>
      );
    }
    if (change.removed) {
      return null;
    }
    return (
      <span className={styles.unchangedInner} key={`unchanged-${lineNumber}-${index}`}>
        {change.value}
      </span>
    );
  });
}

export function buildRemovedLineWordDiffSpans(
  removedValue: string,
  nextAddedValue: string,
  lineNumber: number,
): ReactNode[] {
  return diffWords(removedValue, nextAddedValue).map((change, index) => {
    if (change.removed) {
      return (
        <span key={`removed-${lineNumber}-${index}`} className={styles.removedInner} data-line-removed-inner>
          {change.value}
        </span>
      );
    }
    if (change.added) {
      return null;
    }
    return (
      <span className={styles.unchangedInner} key={`unchanged-${lineNumber}-${index}`}>
        {change.value}
      </span>
    );
  });
}
